import type { ScheduleClass } from 'services/api/schedule-configuration';
import type { EducationClassRow } from '../types';

export const mapEducationClassRowsToScheduleClasses = (
  rows: EducationClassRow[],
): ScheduleClass[] =>
  rows.flatMap((row) => {
    if (row.curriculumId == null || !row.educationClassIds?.length) return [];
    return row.educationClassIds.map((educationalClassId) => ({
      educationalClassId,
      curriculumId: row.curriculumId!,
    }));
  });

export const mapScheduleClassesToEducationClassRows = (
  scheduleClasses: ScheduleClass[],
): EducationClassRow[] => {
  const byCurriculum = new Map<number, number[]>();
  for (const { curriculumId, educationalClassId } of scheduleClasses) {
    const ids = byCurriculum.get(curriculumId) ?? [];
    ids.push(educationalClassId);
    byCurriculum.set(curriculumId, ids);
  }
  return Array.from(byCurriculum.entries()).map(([curriculumId, educationClassIds], index) => ({
    key: `curriculum-${curriculumId}-${index}`,
    curriculumId,
    educationClassIds,
  }));
};
